import classNames from 'classnames'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'

import { Button, TYPE } from 'components/Button'
import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

import PriceWithCurrency from 'components/PriceWithCurrency'
import { SiteCurrency } from 'components/PriceWithCurrency/PriceWithCurrency'
import './FunnelFooter.scss'

interface FunnelFooterProps {
  currency: SiteCurrency
  total: number
  oldTotal: number | null
  giftCardLength: number
  onClickMoreDetails: () => void
  detailsOpen?: boolean
  onClickGiftCard: () => void
  nextStepLink: JSX.Element
  trigger?: JSX.Element
  giftcardNotification?: JSX.Element

  customPaymentMode?: boolean
  hideGiftcardButton?: boolean
  mobilePositionBottom?: boolean
  stickyStop?: boolean

  footerButtonsLayoutClassName?: string
}

interface FunnelFooterState {
  reachedStop: boolean
}

class FunnelFooter extends React.Component<
  FunnelFooterProps,
  FunnelFooterState
> {
  public static defaultProps = {
    customPaymentMode: false,
  }

  public render() {
    const {
      mobilePositionBottom,
      stickyStop,
      customPaymentMode,
      trigger,
      onClickMoreDetails,
      detailsOpen,
      currency,
      total,
      oldTotal,
      hideGiftcardButton,
      onClickGiftCard,
      giftCardLength,
      nextStepLink,
    } = this.props

    const className = classNames(
      'srprs-funnelFooter',
      mobilePositionBottom ? 'is-mobile-position-bottom' : '',
      stickyStop ? 'sticky-stop' : '',
    )
    return (
      <>
        {stickyStop ? (
          <div className="srprs-funnelFooter-reference" ref="ref" />
        ) : null}
        <footer className={className} ref="footer">
          <div className="wrapper-inner">
            <div
              className="details-price-box"
              style={{ display: customPaymentMode ? 'none' : undefined }}
            >
              {trigger}
              <div className="details-row">
                <button className="show-details" onClick={onClickMoreDetails}>
                  {detailsOpen ? (
                    <>
                      <DefaultContent contentKey="close-details">
                        Close details
                      </DefaultContent>
                      <Icon icon={UI.chevronDown} />
                    </>
                  ) : (
                    <>
                      <DefaultContent contentKey="more-details">
                        More details
                      </DefaultContent>
                      <Icon icon={UI.chevronUp} />
                    </>
                  )}
                </button>
                {oldTotal ? (
                  <div className="strike-through">
                    <PriceWithCurrency currency={currency} price={oldTotal} />
                  </div>
                ) : null}
              </div>
              <div className="total-row">
                <span className="total-label">
                  <DefaultContent contentKey="total">Total</DefaultContent>
                </span>
                <div className={`pill ${oldTotal ? 'show' : ''}`}>
                  <PriceWithCurrency currency={currency} price={total} />
                </div>
              </div>
            </div>

            <div className="total-price-box">
              <p className="total-label">
                {oldTotal ? (
                  <s>
                    <PriceWithCurrency currency={currency} price={oldTotal} />
                  </s>
                ) : (
                  <DefaultContent contentKey="total">Total</DefaultContent>
                )}
              </p>
              <div className="total">
                <strong>
                  <PriceWithCurrency currency={currency} price={total} />
                </strong>
              </div>
            </div>
            {customPaymentMode ? (
              ''
            ) : (
              <div className="more-details-box">
                {trigger}
                <Button type={TYPE.inverted} onClick={onClickMoreDetails}>
                  {detailsOpen ? (
                    <>
                      <DefaultContent contentKey="close-details">
                        Close details
                      </DefaultContent>
                    </>
                  ) : (
                    <>
                      <DefaultContent contentKey="more-details">
                        More details
                      </DefaultContent>
                    </>
                  )}
                </Button>
              </div>
            )}
            <div
              className={`funnel-footer-buttons-group${
                this.props.footerButtonsLayoutClassName
                  ? ` ${this.props.footerButtonsLayoutClassName}`
                  : ''
              }`}
            >
              <div className="giftcard-box">
                {this.props.giftcardNotification}
                {customPaymentMode || hideGiftcardButton ? (
                  ''
                ) : (
                  <Button
                    type={TYPE.inverted}
                    cutOff={'none'}
                    onClick={onClickGiftCard}
                  >
                    <DefaultContent contentKey="gift-card">
                      Gift card
                    </DefaultContent>
                    ({giftCardLength})
                  </Button>
                )}
              </div>
              <div className="submit-desktop">{nextStepLink}</div>
            </div>
          </div>
          <div className="submit-mobile">{nextStepLink}</div>
        </footer>
      </>
    )
  }
}

export default FunnelFooter
